// src/pages/AmenityBookingPage.tsx

import React, { useEffect } from "react";
import { Grid2 as Grid, Typography, Paper } from "@mui/material";
import AmenityCard from "./AminityCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Redux/Reducer/rootReducer";
import { fetchAmenities } from "../../Redux/selectors";

const AmenityBookingPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const amenitiesList = useSelector(fetchAmenities);

  useEffect(() => {
    dispatch(Actions.fetchAmenities.amenityActions.request({}));
  }, []);

  const handleBookAmenity = (amenity: number) => {
    navigate(`/createBookingCalender`, { state: { amenity } });
  };

  // const amenities = [
  //   {
  //     title: "Elevator",
  //     description: "Use our elevator to access all floors when moving luggage.",
  //     image: ElevatorImage
  //   },
  //   {
  //     title: "Party Room",
  //     description: "Book our party room for events and celebrations.",
  //     image: PartyRoomImage,
  //   }
  // ];

  return (
    <Paper elevation={5} sx={{ padding: 3, borderRadius: 3}}>
      <Typography variant="h3" gutterBottom>
        Bookings
      </Typography>
      <Typography variant="h6" color="textSecondary" paragraph>
        Select an amenity and book it now!
      </Typography>
      <Grid container spacing={4}>
        {amenitiesList?.map((amenity) => (
          <Grid key={amenity.title}>
            <AmenityCard
              title={amenity.title}
              description={amenity.description}
              image={amenity.picture}
              onBook={() => amenity.id !== undefined && handleBookAmenity(amenity.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default AmenityBookingPage;
